"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_class_component_1 = require("vue-class-component");
var campaign_model_1 = require("../../../model/campaign.model");
var vue_property_decorator_1 = require("vue-property-decorator");
var State_vue_1 = require("../../campaign/State.vue");
var StateComponent = (function (_super) {
    __extends(StateComponent, _super);
    function StateComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StateComponent.prototype, "campaignStates", {
        get: function () {
            return [
                {
                    value: campaign_model_1.CampaignStatusEnum.CREATING,
                    text: this.$tc('campaigns.state.creating') +
                        ' ' +
                        this.$tc('campaigns.state.filter_creating_tip')
                },
                {
                    value: campaign_model_1.CampaignStatusEnum.RUNNING,
                    text: this.$tc('campaigns.state.running')
                },
                {
                    value: campaign_model_1.CampaignStatusEnum.PAUSED,
                    text: this.$tc('campaigns.state.paused')
                },
                {
                    value: campaign_model_1.CampaignStatusEnum.OBJECTIVE_REACHED,
                    text: this.$tc('campaigns.state.objective_reached')
                },
                {
                    value: campaign_model_1.CampaignStatusEnum.FINISHED,
                    text: this.$tc('campaigns.state.finished')
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        vue_property_decorator_1.Prop(),
        __metadata("design:type", Object)
    ], StateComponent.prototype, "filter", void 0);
    StateComponent = __decorate([
        vue_class_component_1.default({
            components: { CampaignStateComponent: State_vue_1.default }
        })
    ], StateComponent);
    return StateComponent;
}(vue_1.default));
exports.default = StateComponent;
